import { render } from "./AlignedUsers.vue?vue&type=template&id=550907a6&scoped=true"
import script from "./AlignedUsers.vue?vue&type=script&lang=js"
export * from "./AlignedUsers.vue?vue&type=script&lang=js"

import "./AlignedUsers.vue?vue&type=style&index=0&id=550907a6&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-550907a6"]])

export default __exports__